/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import PDF from 'react-pdf-js';
import { titleize } from 'underscore.string';
import { isPDFEncrypted } from 'utils/documents';
import Alert from 'components/ui/Alert';
class PDFViewer extends Component {
    constructor(props) {
        super(props);
        this.onDocumentComplete = (pages) => {
            this.setState({ page: 1, pages });
        };
        this.onPageComplete = (page) => {
            this.setState({ page });
        };
        this.handlePrevious = () => {
            this.setState((prevState) => ({ page: prevState.page - 1 }));
        };
        this.handleNext = () => {
            this.setState((prevState) => ({ page: prevState.page + 1 }));
        };
        this.renderPDF = () => {
            const { t } = this.props;
            if (this.state.loading) {
                return React.createElement("div", { "data-testid": "div-c45499de" }, titleize(t('LOADING')));
            }
            if (this.state.encrypted) {
                return React.createElement(Alert, { dataTestId: "Alert-67e0a532", type: "error" }, t('PDF_DOCUMENT_ENCRYPTED'));
            }
            let pagination = null;
            if (this.state.pages && this.state.pages > 1) {
                pagination = this.renderPagination(this.state.page, this.state.pages);
            }
            if (this.props.displayInGridView) {
                return ((React.createElement("div", { "data-testid": "div-41ab2888" },
                    React.createElement("a", { "data-testid": "a-ea3a231e", href: this.props.file, target: "_blank", rel: "noreferrer" },
                        React.createElement(PDF, { style: {
                                height: this.props.height || '125px',
                                width: this.props.width || '100px',
                                maxWidth: '100%',
                            }, file: this.props.file, onDocumentComplete: this.onDocumentComplete, onPageComplete: this.onPageComplete, page: this.state.page })))));
            }
            return ((React.createElement("div", { "data-testid": "div-a26cb15c" },
                React.createElement(PDF, { file: this.props.file, onDocumentComplete: this.onDocumentComplete, onPageComplete: this.onPageComplete, page: this.state.page, style: this.props.pdfStyle }),
                pagination)));
        };
        this.state = {
            loading: true,
            encrypted: false,
        };
    }
    async componentDidMount() {
        if (this.props.file instanceof File) {
            const encrypted = await isPDFEncrypted(this.props.file);
            this.setState({ loading: false, encrypted });
        }
        else {
            this.setState({ loading: false });
        }
    }
    renderPagination(page, pages) {
        const { t } = this.props;
        let previousButton = (React.createElement("li", { "data-testid": "li-29a9a5b7", className: "previous", onClick: this.handlePrevious },
            React.createElement("a", { "data-testid": "a-a9e08393", href: "#" },
                React.createElement("i", { "data-testid": "i-ab4bb080", className: "fa fa-arrow-left" }),
                titleize(t('PREVIOUS')))));
        if (page === 1) {
            previousButton = (React.createElement("li", { "data-testid": "li-d690e2ae", className: "previous disabled" },
                React.createElement("a", { "data-testid": "a-d2feff9d", href: "#" },
                    React.createElement("i", { "data-testid": "i-23ecee17", className: "fa fa-arrow-left" }),
                    " ",
                    titleize(t('PREVIOUS')))));
        }
        let nextButton = (React.createElement("li", { "data-testid": "li-e8d4ef61", className: "next", onClick: this.handleNext },
            React.createElement("a", { "data-testid": "a-bbb99462", href: "#" },
                titleize(t('NEXT')),
                " ",
                React.createElement("i", { "data-testid": "i-7dab8ca7", className: "fa fa-arrow-right" }))));
        if (page === pages) {
            nextButton = (React.createElement("li", { "data-testid": "li-49ba718d", className: "next disabled" },
                React.createElement("a", { "data-testid": "a-b864ced4", href: "#" },
                    titleize(t('NEXT')),
                    " ",
                    React.createElement("i", { "data-testid": "i-ab509617", className: "fa fa-arrow-right" }))));
        }
        return ((React.createElement("nav", { "data-testid": "nav-be12bf97" },
            React.createElement("ul", { "data-testid": "ul-98c45475", className: "pager" },
                previousButton,
                nextButton))));
    }
    render() {
        return this.renderPDF();
    }
}
export default withTranslation()(PDFViewer);
